import { useEffect } from 'react'
import { useLocation } from 'react-router'

const ScrollReset = () => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
    // eslint-disable-next-line
  }, [location.pathname])

  return null
}

export default ScrollReset
